import {OWN_FORMULA_SOURCE} from "../constants/formulaTypes";

export function getOwnFormulaSource(matchingFormula = false, imported = false) {
    if (matchingFormula) {
        return OWN_FORMULA_SOURCE.MATCHING;
    }
    if (imported) {
        return OWN_FORMULA_SOURCE.IMPORTED;
    }

    return OWN_FORMULA_SOURCE.USER_CREATED;
}
